import { sendNachrichtKeys } from "../nachricht/send/sendNachrichtQueries";

export const kundeQueries = {
    all: () => ["kunde"],
    detail: (kundId) => [...kundeQueries.all(), kundId],
    search: (searchTerm) => [...kundeQueries.all(), "search", searchTerm],
    // The message composer reads the same GET /kunden/{id} payload as `detail`, only with its own
    // lifetime. It hangs under the customer root so one invalidation reaches every cached copy of
    // a customer instead of the copy the writer happened to think of.
    messageData: (kundId) => [...kundeQueries.detail(kundId), "messageData"],
};

/**
 * Every cache that holds customer data.
 *
 * The composer's appointment payload carries customer, project and appointment in one response and
 * is keyed by terminId, so it cannot hang under the customer root - it is named here instead. The
 * whole `sendNachricht` root is taken deliberately: everything cached there is customer data, and
 * naming a single leaf is how the next query added there would be missed again.
 */
export const kundeInvalidationKeys = [kundeQueries.all(), sendNachrichtKeys.all];

/**
 * Call after a successful write of customer or customer-project data, not before: invalidation
 * refetches active queries, so an early call would put the pre-write state back into the cache.
 */
export const invalidateKundeQueries = (queryClient) => {
    kundeInvalidationKeys.forEach((queryKey) => {
        queryClient.invalidateQueries({ queryKey, exact: false });
    });
};
